// Program core
export function programCore() {
  const endpoint = '/programs';
  const detailId = 'programId';

  const getDetailId = (data = null) => {
    if (!data) {
      return;
    }

    if (Array.isArray(data)) {
      return data[0][detailId];
    }

    return data[detailId];
  };

  return {
    endpoint,
    detailId,
    getDetailId: getDetailId
  };
}

// Program filter
export function programFilter() {
  const parameter = 'ProgramId';

  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.programId,
        label: row.programName
      };
    });

    return rows;
  };

  return {
    parameter,
    getRows: getRows
  };
}
